import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { node } from 'prop-types';

import VerificationProvider from 'Src/common/providers/verification';
import ApplyForVerification from 'Src/common/components/verifications/applyForVerification';
import WaitingScreen from 'Src/common/components/waitingScreen';
import history from 'Src/common/utilities/history';
import { getVerificationStatus } from '../actions';
import Home from './home';

function VerificationWrapper({ children }) {
  const [vfxData, setVfxData] = useState({
    isVerifying: false,
    isVerified: false,
    isError: true,
    groups: [],
  });
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, user, logout } = useAuth0();

  const handleRedirect = () => {
    history.push('/mentorship');
  };

  async function getVerification() {
    setLoading(true);
    try {
      const response = await getVerificationStatus(window.programDetails.id);
      setVfxData(response.data);
      setLoading(false);

      return response.data;
    } catch (error) {
      setLoading(false);

      return {
        isVerifying: false,
        isVerified: false,
        isError: true,
        groups: [],
      };
    }
  }

  if (!window.isUserAuthenticated) {
    return window.open('/login?next=/mentorship', '_self');
  }

  return (
    <VerificationProvider getVerification={getVerification}>
      <div>
        <Choose>
          <When condition={loading}>
            <WaitingScreen title="Checking Verification" />
          </When>
          <Otherwise>
            <Choose>
              <When condition={vfxData.is_verified}>{children}</When>
              <Otherwise>
                <Home />
                <ApplyForVerification
                  groups={vfxData.groups}
                  user={isAuthenticated ? user : window.userData}
                  isSessionAuthenticated={window.isUserAuthenticated}
                  isAuthenticated={isAuthenticated}
                  isNewUser={vfxData.isNewUser}
                  closeModal={handleRedirect}
                  logout={() =>
                    logout({
                      returnTo: `${window.location.origin}/s/auth0/logout?returnTo=${
                        window.location.origin + window.location.pathname
                      }`,
                    })
                  }
                  collegeEmail={window.collegeEmail}
                  collegeName={window.collegeName}
                />
              </Otherwise>
            </Choose>
          </Otherwise>
        </Choose>
      </div>
    </VerificationProvider>
  );
}

VerificationWrapper.propTypes = {
  children: node.isRequired,
};

export default VerificationWrapper;
